export const MUSIC_ASSET_BASE_PATH = './assets/music/';

export const BGM_TRACKS = Object.freeze({
  more_relaxed: { file: 'More Relaxed.mp3', title: 'More Relaxed', style: 'cozy', baseVolume: 0.12 },
  floating_trees_up: { file: 'Floating Trees Up.mp3', title: 'Floating Trees Up', style: 'airy', baseVolume: 0.115 },
  bouncing_trees: { file: 'Bouncing Trees.mp3', title: 'Bouncing Trees', style: 'playful', baseVolume: 0.115 },
  fragments_trees: { file: 'Fragments Trees.mp3', title: 'Fragments Trees', style: 'mysterious', baseVolume: 0.11 },
  peaceful_campfire: { file: 'Peaceful Campfire.mp3', title: 'Peaceful Campfire', style: 'cozy', baseVolume: 0.118 },
  cobblestone_daydream: { file: 'Cobblestone Daydream.mp3', title: 'Cobblestone Daydream', style: 'nostalgic', baseVolume: 0.11 },
  soft_and_warm: { file: 'Soft and Warm.mp3', title: 'Soft and Warm', style: 'cozy', baseVolume: 0.115 },
  gentle_days: { file: 'Gentle Days.mp3', title: 'Gentle Days', style: 'mellow', baseVolume: 0.112 },
  cobblestone_stair: { file: 'Cobblestone Stair.mp3', title: 'Cobblestone Stair', style: 'stone', baseVolume: 0.106 },
  kindly_wind: { file: 'Kindly Wind.mp3', title: 'Kindly Wind', style: 'airy', baseVolume: 0.115 },
  stone_cave: { file: 'Stone Cave.mp3', title: 'Stone Cave', style: 'stone', baseVolume: 0.102 },
  stone_drop: { file: 'Stone Drop.mp3', title: 'Stone Drop', style: 'stone', baseVolume: 0.1 },
  elf_forest: { file: 'Elf Forest.mp3', title: 'Elf Forest', style: 'forest', baseVolume: 0.114 },
  snow_city: { file: 'Snow City.mp3', title: 'Snow City', style: 'winter', baseVolume: 0.108 },
  gift_days: { file: 'Gift Days.mp3', title: 'Gift Days', style: 'festive', baseVolume: 0.11 },
  crafting_memory: { file: 'Crafting Memory.mp3', title: 'Crafting Memory', style: 'nostalgic', baseVolume: 0.108 },
  fleeting_snow: { file: 'Fleeting Snow.mp3', title: 'Fleeting Snow', style: 'winter', baseVolume: 0.106 }
});

function createPool(label, tracks) {
  return Object.freeze({
    label,
    tracks: Object.freeze(tracks.map((entry) => Object.freeze(entry)))
  });
}

export const BGM_POOLS = Object.freeze({
  overworld: createPool('Overworld Calm', [
    { id: 'more_relaxed', weight: 1.45 },
    { id: 'peaceful_campfire', weight: 1.35 },
    { id: 'soft_and_warm', weight: 1.3 },
    { id: 'gentle_days', weight: 1.22 },
    { id: 'kindly_wind', weight: 1.2 },
    { id: 'cobblestone_daydream', weight: 1.02 },
    { id: 'bouncing_trees', weight: 0.96 },
    { id: 'floating_trees_up', weight: 0.92 },
    { id: 'gift_days', weight: 0.8 },
    { id: 'crafting_memory', weight: 0.72 },
    { id: 'elf_forest', weight: 0.55 }
  ]),
  overworld_forest: createPool('Overworld Forest', [
    { id: 'elf_forest', weight: 1.55 },
    { id: 'floating_trees_up', weight: 1.25 },
    { id: 'kindly_wind', weight: 1.15 },
    { id: 'bouncing_trees', weight: 1.08 },
    { id: 'fragments_trees', weight: 0.95 },
    { id: 'peaceful_campfire', weight: 0.86 },
    { id: 'more_relaxed', weight: 0.8 },
    { id: 'gentle_days', weight: 0.76 },
    { id: 'fleeting_snow', weight: 0.3 }
  ]),
  overworld_tense: createPool('Overworld Tense', [
    { id: 'stone_cave', weight: 1.42 },
    { id: 'stone_drop', weight: 1.36 },
    { id: 'fragments_trees', weight: 1.2 },
    { id: 'cobblestone_stair', weight: 1.06 },
    { id: 'cobblestone_daydream', weight: 0.74 },
    { id: 'crafting_memory', weight: 0.7 },
    { id: 'snow_city', weight: 0.42 }
  ]),
  nether: createPool('Nether', [
    { id: 'stone_cave', weight: 1.5 },
    { id: 'stone_drop', weight: 1.45 },
    { id: 'fragments_trees', weight: 1.22 },
    { id: 'cobblestone_stair', weight: 1.06 },
    { id: 'crafting_memory', weight: 0.84 },
    { id: 'snow_city', weight: 0.52 },
    { id: 'fleeting_snow', weight: 0.36 }
  ]),
  end: createPool('End', [
    { id: 'fleeting_snow', weight: 1.45 },
    { id: 'snow_city', weight: 1.2 },
    { id: 'floating_trees_up', weight: 1.0 },
    { id: 'crafting_memory', weight: 0.95 },
    { id: 'gift_days', weight: 0.78 },
    { id: 'more_relaxed', weight: 0.74 },
    { id: 'kindly_wind', weight: 0.66 }
  ])
});
